import { LocalDate } from 'js-joda';
import { core } from '@tock/coretypes';
import { filter, map } from 'es-toolkit/compat';


import { IconChampagne, IconGift } from '@tock/icons';
import protos from 'utils/protos';

const { PatronProfile } = protos;

export function getTitleForType(type: core.PatronProfile.DayType) {
  switch (type) {
    case 'BIRTHDAY':
      return 'Your birthday';
    case 'PARTNER_BIRTHDAY':
      return "Partner's birthday";
    case 'ANNIVERSARY':
      return 'Your anniversary';
    default:
      return 'Special day';
  }
}

export function getIconForType(type: core.PatronProfile.DayType): JSX.Element {
  switch (type) {
    case 'PARTNER_BIRTHDAY':
      return (
        <div className="ImportantDate-icon--partner-birthday">
          <IconGift className="ImportantDate-icon-size" />
        </div>
      );
    case 'BIRTHDAY':
      return (
        <div className="ImportantDate-icon--birthday">
          <IconGift className="ImportantDate-icon-size" />
        </div>
      );
    case 'ANNIVERSARY':
      return (
        <div className="ImportantDate-icon--anniversary">
          <IconChampagne className="ImportantDate-icon-size" />
        </div>
      );
    default:
      //TODO
      return <div></div>;
  }
}

export function profileDayToDate(day: core.PatronProfileDay): LocalDate {
  return LocalDate.of(day.year, day.month, day.day);
}

export const optionsForDayType = map(
  filter(Object.keys(PatronProfile.DayType), (value) => value !== 'OTHER_BIRTHDAY'),
  (key) => {
    return { key, value: key, label: getTitleForType(key as core.PatronProfile.DayType) };
  }
);
